import $ from 'jquery';

$('.form-fileupload-wrap').each(function () {
    let $children = $(this).children('.form-group')
    let index = 0;

    $children.each(function () {
        if(index !== 0) {
            $(this).addClass('form-group--hidden');
        }

        index++;
    })

    $children.each(function () {
        let $input = $(this).find('input');
        if($input.val() !== '') {
            $(this).closest('.form-group').prevAll().removeClass('form-group--hidden')
            $(this).closest('.form-group').next().removeClass('form-group--hidden')
        }
    })

    $children.find('input').on('change', function () {
        $(this).closest('.form-group').prevAll().removeClass('form-group--hidden')
        $(this).closest('.form-group').next().removeClass('form-group--hidden')
    })
})